// extracted by mini-css-extract-plugin
export default {"root":"TrendCard_root__jW3py","body":"TrendCard_body__A0ef9"};